import { h } from 'preact'
import VerifiedByVisa from '../../assets/icons/Verified-by-Visa.svg'
import MastercardSecureCode from '../../assets/icons/MasterCardSecueCode.svg'
import styles from './CardsVerification.module.scss'

const verifications = [
  {
    logo: VerifiedByVisa,
    title: 'Verified by Visa',
    type: 'Visa',
  },
  {
    logo: MastercardSecureCode,
    title: 'Mastercard secure code',
    type: 'MasterCard',
  },
]

const CardsVerificationInfo = props => {
  const { prohibitedCardBrands } = props
  const filteredLogos = verifications.filter(
    el => !prohibitedCardBrands?.includes(el.type),
  )

  return (
    <div className={styles.cardsVerification}>
      {filteredLogos.map(item => (
        <img
          src={item.logo}
          key={item.title}
          alt={item.title}
          data-testid={item.type}
        />
      ))}
    </div>
  )
}

export default CardsVerificationInfo
